import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const CapeUsageMonitoringReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.CAPE_USAGE_MONITORING_1000.id,
        label: 'Report',
      },
      {
        value: ReportDefinitions.CAPE_USAGE_MONITORING_BY_OPERATOR_1000.id,
        label: 'Operator',
      },
      {
        value: ReportDefinitions.CAPE_USAGE_MONITORING_BY_OPERATOR_USER_1000.id,
        label: 'User',
      },
    ]}
    className="no-stripe"
    {...props}
  />
);
export default CapeUsageMonitoringReport;

CapeUsageMonitoringReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
